module.exports = __webpack_public_path__ + "static/img/icon-lab-03.91dbf607.png";